module.exports = __webpack_public_path__ + "static/media/pencil.c5ef0c12.svg";